import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'
import styles from './BotList.module.css'
import classNames from 'classnames'
import { message, Typography, Pagination, Select, Button } from 'antd'
import { useDispatch } from 'react-redux'
import { HTTP_URL } from '../../../../util/constants'
import Cookies from 'js-cookie'
import { getBotsListRequest } from './BotAndDatasetListApi'
import { clearAllCookies } from '../../../../util/handleObject'
import HeaderBar from '../HeaderBar'
import BotItem from './BotItem'
const { Text } = Typography
// export default function BotList(props) {
const BotList = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [botMenus, setBotMenus] = useState([
    {
      key: '1',
      label: <div>进入智能体</div>,
    },
    {
      key: '2',
      label: <div>编辑</div>,
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '3',
      label: <div>删除</div>,
    },
  ])
  const [botMenus1, setBotMenus1] = useState([
    {
      key: '1',
      label: <div>进入智能体</div>,
    },
    {
      key: '2',
      label: <div>编辑</div>,
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '4',
      label: <div>下架</div>,
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '3',
      label: <div>删除</div>,
    },
  ])
  const [botList, setBotList] = useState([])
  const [botNumber, setBotNumber] = useState(0)
  const [botItem, setBotItem] = useState(0)
  const [botCurrentPage, setBotCurrentPage] = useState(1)
  const [botPageSize, setBotPageSize] = useState(15)
  const [botStatus, setBotStatus] = useState('')

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getBotList(botStatus,'0', '15')
    return () => {}
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  useImperativeHandle(ref, () => ({
    getBotListFn() {
      getBotList(
        botStatus,
        String(botPageSize * (botCurrentPage - 1)),
        String(botPageSize),
      )
    },
  }))
  function getBotList(status,offSet, limit) {
    getBotsListRequest(Cookies.get('coze_space_id'),status, offSet, limit, (data) => {
      console.log(data)
      if (data.ret == 1) {
        let botList = data.botInfo.DB_bot_list
        setBotList(botList)
        setBotNumber(data.botInfo.total_num)
      } else if (data.ret == 99) {
        messageApi.open({
          type: 'warning',
          // content: data.msg,
          content: data.msg,
        })
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.warning(data.msg)
      }
    })
  }

  const onShowSizeChange = (current, pageSize) => {
    setBotCurrentPage(current)
    setBotPageSize(pageSize)
    let offSet = pageSize * (current - 1)
    getBotList(botStatus,String(offSet), String(pageSize))
  }
  const pageChange = (current, pageSize) => {
    setBotCurrentPage(current)
    setBotPageSize(pageSize)
    let offSet = pageSize * (current - 1)
    getBotList(botStatus,String(offSet), String(pageSize))
  }

  const clickBotItem = (item) => {
    window.open(
      HTTP_URL +
        `gongju/preview/index.html?botId=${item.bot_id}&icon=${btoa(item.icon_url)}&title=${item.bot_name}&userToken=${Cookies.get('userToken')}`,
    )
  }
  return (
    <div className={styles.background} style={{ paddingBottom: 30 }}>
      <div className={styles.topBox}>
        <div style={{ width: 160 }}>
          <span>状态</span>
          <Select
            style={{ marginLeft: 30, width: 88,backgroundColor:'white' }}
            onChange={(value) => {
              setBotStatus(value)
              getBotList(
                value,
                String(botPageSize * (botCurrentPage - 1)),
                String(botPageSize),
              )
            }}
            value={botStatus}
            options={[
              { value: '', label: <span>全部</span> },
              { value: '2', label: <span>已发布</span> },
              { value: '1', label: <span>未发布</span> },
            ]}
          />
        </div>
        <Button
          color="primary"
          variant="outlined"
          style={{ marginLeft: 30 ,marginRight: 34,backgroundColor:'white' }}
          onClick={props.backMethod}
        >
          返回上一页面
        </Button>
      </div>
      <div className={styles.botListBox}>
        {botList.map((item, index) => (
          <BotItem
            key={index}
            info={item}
            index={index}
            clickBotItem={clickBotItem}
            getBotList={() =>
              getBotList(
                botStatus,
                String(botPageSize * (botCurrentPage - 1)),
                String(botPageSize),
              )
            }
            getEduBotList={() =>{
              props.getEduBotList()
            }
            }
            editMethod={props.editMethod}
            shareBotItem={props.shareBotItem}
          />
        ))}
      </div>
      <Pagination
        align="end"
        defaultCurrent={botCurrentPage}
        total={botNumber}
        pageSize={botPageSize}
        pageSizeOptions={[15, 20, 25, 30, 35, 40]}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onChange={pageChange}
        style={{ marginRight: 64 }}
      />
    </div>
  )
})
export default BotList
